$(function() {
  $('.toggle-icon').click(function(){
    $(this).toggleClass('show-toggle');
    var input = $(this).parent().find('input');
    if($(input).attr('type') == 'password'){
      $(input).attr('type', 'text')
    }else{
      $(input).attr('type', 'password')
    }
  })

  $('.survey-toggle').click(function(){
    $(this).next().slideToggle();
    $(this).toggleClass('change')
  })

  var code = $('.form-selector .dropdown-toggle span').text();
  $('input.country-code').val(code)
  $('.form-selector .dropdown-menu a').click(function(e){
    e.preventDefault();
    var thisHtml = $(this).html();
    code = $(this).find('span').text();
    $('.form-selector .dropdown-toggle').html(thisHtml);
    $('input.country-code').val(code)
  })

  $.validator.addMethod('filesize', function (value, element, param) {
    return this.optional(element) || (element.files[0].size <= param)
  }, 'File size must be less than {0}');

  $.validator.addMethod("extension", function(value, element, param) {
      param = typeof param === "string" ? param.replace(/,/g, '|') : "png|jpe?g|gif";
      return this.optional(element) || value.match(new RegExp(".(" + param + ")$", "i"));
  }, "Please enter a value with a valid extension.");

  var defaultRangeValidator = $.validator.methods.range;
  $.validator.methods.range = function (value, element, param) {
      if (element.type === 'checkbox') {
          // if it's a checkbox return true if it is checked
          return element.checked;
      } else {
          // otherwise run the default validation function
          return defaultRangeValidator.call(this, value, element, param);
      }
  }

  $(".form input[type='submit']").click(function () {
    var myforms = $(this).parent();
    if (myforms.valid()) {
        grecaptcha.execute();
        return false;
    }
  });

  $(".form-contact .btn-secondary").on('click', function(){
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'eventCategory': 'contact_us',
        'eventAction': 'contact_us_intention',
        'eventLabel': window.location.href,
        'eventvalue':'',
        'event': 'eventClick'
    });
  })
  if($('input[name="Attachment"]').length){
    $('input[name="Attachment"]').valid();
    $('input[name="Attachment"]').rules('add', {
      filesize: 5242880,
      extension: "jpe?g|png|gif|pdf"
    });
  }
  $('input[name="Attachment"]').change(function(){
      $(this).valid();
  });
  var filePlaceholder = $(".custom-file").text();

  $('#Attachment').change(function () {
    var sizeFile = this.files[0].size;
    var fileName = $(this).val().replace(/C:\\fakepath\\/i, '');
    var fileType = fileName.substr( (fileName.lastIndexOf('.') +1) );
    var imgFile = '';

    if(fileType === 'jpeg' || fileType === 'jpg' || fileType === 'png' || fileType === 'gif'){
      imgFile = 'images/icons/ICON_IMG.svg';
    }else if(fileType === 'pdf'){
      imgFile = 'images/icons/ICON_PDF.svg';
    }else{
      imgFile = 'images/icons/ICON_ERROR.svg';
    }

    // $(".input-file b").text(bytesToSize(sizeFile) + "/5 MB");
    // $(this).attr('disabled', true);
    $(".custom-file").text(fileName).addClass('added-file');
    if($('.file-img').length){
      $('.file-img').attr('src', imgFile);
    }else{
      $(".custom-file").before('<img class="file-img" src="' + imgFile + '" alt="">')
    }
    $(".custom-file + .delete-file").show();
  });

  $('.input-file .delete-file').click(function(e){
    e.preventDefault();
    var parentFile = $(this).parent()
    // parentFile.find('#Attachment').val('').attr('disabled', false);
    parentFile.find('.custom-file').text(filePlaceholder).removeClass('added-file');
    parentFile.find('.file-img').remove();
    parentFile.find('#Attachment-error').hide();
    $(".custom-file + .delete-file").hide();
  })

  $('#Message').keyup(function(event) {
    var numberOfchars = event.currentTarget.value.length;
    if(numberOfchars>180) {
        event.preventDefault();
    } else {
        $('.countChars').html((180 - numberOfchars));
    }
  });
  //Validate messsage and characters
  $('#Message').on("keypress keyup blur",function (event) {    
      var regex = new RegExp("^[a-zA-Z0-9 .,¿?¡!áàâãéêíóôõúüñÑçÁÀÂÃÉÊÍÓÔÕÚÜÇ]+$");
      var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      !regex.test(key) ? event.preventDefault() : '';
  });

  $('input[name="cellphone"], input[name="phone"], input[name="PhoneNumber"]').on("keypress keyup blur", function(event) {
    return isNumberKey(event)
  })

  $('.password').keyup(function(event) {
    CheckPasswordStrength($(this).val());
  })


  function bytesToSize(bytes) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 Byte';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i)) + ' ' + sizes[i];
  };

  function isNumberKey(evt){
    var charCode = (evt.which) ? evt.which : evt.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57))
        return false;
    return true;
  }

  function CheckPasswordStrength(password) {
    var password_strength = $(".checker-text");
    var password_blocks = $(".checker-blocks");


      //if textBox is empty
      if(password.length==0){
          $(password_strength).html('');
          $(password_blocks).removeClass('low-strength medium-strength high-strength');
          return;
      }

      //Regular Expressions
      var regex = new Array();
      regex.push("[A-Z]"); //For Uppercase Alphabet
      regex.push("[a-z]"); //For Lowercase Alphabet
      regex.push("[0-9]"); //For Numeric Digits
      regex.push("[$@$!%*#?&]"); //For Special Characters

      var passed = 0;

      //Validation for each Regular Expression
      if(password.length >= 8){
        passed++;
        for (var i = 0; i < regex.length; i++) {
            if((new RegExp (regex[i])).test(password)){
                passed++;
            }
        }
      }

      //Display of Status
      var classCheker = "";
      var passwordStrength = "";
      switch(passed){
          case 0:
              $(password_blocks).removeClass('low-strength medium-strength high-strength');
              break;
          case 1:
              break;
          case 2:
              passwordStrength = $(password_strength).attr('data-low');
              classCheker = "low-strength";
              $(password_blocks).removeClass('medium-strength high-strength')
              $(password_blocks).addClass(classCheker);
              break;
          case 3:
              passwordStrength = $(password_strength).attr('data-medium');
              classCheker = "medium-strength";
              $(password_blocks).removeClass('low-strength high-strength');
              // password_blocks.classList.add(classCheker);
              $(password_blocks).addClass(classCheker);
              break;
          case 4:
              passwordStrength = $(password_strength).attr('data-medium');
              classCheker = "medium-strength";
              $(password_blocks).removeClass('low-strength high-strength');
              $(password_blocks).addClass(classCheker);
              break;
          case 5:
              passwordStrength = $(password_strength).attr('data-high');
              classCheker = "high-strength";
              $(password_blocks).removeClass('medium-strength low-strength')
              $(password_blocks).addClass(classCheker);
              break;
      }
      $(password_strength).html(passwordStrength);
  }

});

function loginSubmit(response) {
  var formLogin = $(".form-login");

  if (grecaptcha.getResponse()) {
      formLogin.submit();
  }
  else {
      grecaptcha.reset();
      grecaptcha.execute();
  }
}
function registerSubmit(response) {
  var formRegister = $(".form-register");

  if (grecaptcha.getResponse()) {
      formRegister.submit();
  }
  else {
      grecaptcha.reset();
      grecaptcha.execute();
  }
}
function contactSubmit(response) {
  var formContact = $(".form-contact");

  if (grecaptcha.getResponse()) {
      formContact.submit();
  }
  else {
      grecaptcha.reset();
      grecaptcha.execute();
  }
}
function forgotPassSubmit(response) {
  var formForgot = $(".form-forgotPass");

  if (grecaptcha.getResponse()) {
      formForgot.submit();
  }
  else {
      grecaptcha.reset();
      grecaptcha.execute();
  }
}
function resetPassSubmit(response) {
  var formReset = $(".form-resetPass");

  if (grecaptcha.getResponse()) {
      formReset.submit();
  }
  else {
      grecaptcha.reset();
      grecaptcha.execute();
  }
}
function subscribeSubmit(response) {
  var formReset = $(".form-subscribe");

  if (grecaptcha.getResponse()) {
      formReset.submit();
  }
  else {
      grecaptcha.reset();
      grecaptcha.execute();
  }
}